import styled from 'styled-components';
import { QuestionBlockStatus } from '../../types';

export const CardsGrid = styled.div`
  width: 100%;
  align-self: stretch;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 24px;
`;

export const BlockCta = styled.button<{ $completed?: boolean }>`
  display: flex;
  width: 100%;
  height: 36px;
  margin-top: 16px;
  padding: var(--spacing-2, 8px) var(--spacing-3, 12px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1, 4px);

  border-radius: var(--radius-md, 8px);
  border: none;
  background: ${({ $completed }) =>
    $completed ? 'var(--Mensagens-Success, #62cf7a)' : 'var(--Primary-Purple, #5768ff)'};

  box-shadow: 0px 1px 2px 0px rgba(18, 18, 23, 0.05);

  color: var(--escala-de-cinza-0, #fff);
  font-family: Manrope;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.42px;

  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    filter: opacity(0.85);
  }

  &:disabled {
    cursor: default;
    filter: opacity(0.2);

    &:hover {
      filter: opacity(0.2);
    }
  }
`;

export const BlockCard = styled.div<{ $completed?: boolean }>`
  display: flex;
  flex-direction: column;

  padding: 16px;
  gap: 8px;

  border-radius: var(--radius-md, 8px);
  border: 1px solid
    ${({ $completed }) =>
      $completed ? 'var(--Mensagens-Success, #62cf7a)' : 'var(--escala-de-cinza-10, #efefef)'};
  background: var(--escala-de-cinza-0, #fff);
  box-shadow: 0px 1px 2px 0px rgba(18, 18, 23, 0.05);

  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 2px 8px 0px rgba(18, 18, 23, 0.1);
  }
`;

export const BlockTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const BlockTitle = styled.span`
  color: var(--escala-de-cinza-90, #101010);
  font-family: 'DM Sans';
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
`;

export const StatusBadge = styled.span<{ $status: QuestionBlockStatus }>`
  flex-shrink: 0;
  font-family: Manrope;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 999px;
  color: ${({ $status }) =>
    $status === 'not_started' ? 'var(--escala-de-cinza-90, #101010)' : '#fff'};
  background: ${({ $status }) =>
    $status === 'completed'
      ? 'var(--Mensagens-Success, #62cf7a)'
      : $status === 'in_progress'
        ? 'var(--Primary-Purple, #5768ff)'
        : 'var(--escala-de-cinza-10, #efefef)'};
`;

export const QuestionsCount = styled.span`
  color: var(--escala-de-cinza-50, #858585);
  font-family: Manrope;
  font-size: 14px;
  font-weight: 500;
`;

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: var(--escala-de-cinza-10, #efefef);
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $percent: number }>`
  height: 100%;
  border-radius: 999px;
  background: var(--Primary-Purple, #5768ff);
  width: ${({ $percent }) => `${$percent}%`};
  transition: width 0.2s ease;
`;

export const WholeLectureRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid var(--escala-de-cinza-10, #efefef);
`;

export const WholeLectureHint = styled.span`
  color: var(--escala-de-cinza-50, #858585);
  font-family: Manrope;
  font-size: 14px;
`;

export const EmptyState = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 20px;
  margin-top: 24px;
  color: var(--escala-de-cinza-50, #858585);
  font-family: Manrope;
  font-size: 14px;
`;
